<template>
  <AppSection
    id="allowed-countries"
    :title="$getConst.pages.sms_configuration.sms_allowed_countries_menu_title"
    type="sub-section-1"
    :is-section-loading="isLoading"
    :set-min-height="false"
    class="mb-4"
  >
    <b-form-group id="countries" :label="$t($getConst.pages.sms_configuration.sms_countries_label)" label-for="countries-input">
      <multiselect
        id="countries-input"
        v-model="allowedCountries"
        :disabled="!hasPermission($getConst.permissions.writeSmsSettings)"
        :options="allCountries"
        :multiple="true"
        :close-on-select="false"
        :clear-on-select="true"
        :placeholder="$t(this.$getConst.pages.form.select_option)"
        label="name"
        track-by="iso2"
        @close="updateAllowedCountries"
      >
        <template slot="option" slot-scope="props">
          <span class="mr-2">(+{{props.option.dialCode}})</span>{{props.option.name}}
        </template>
        <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
      </multiselect>
    </b-form-group>
  </AppSection>
</template>

<script>
  import AppSection from "../../../../../components/common/sections/AppSection";
  import {countries} from "../../../../../shared/constants/countries/phoneCodeCountries";
  import {addAllowedMobileCountries, getAllowedMobileCountriesPerScope} from "../../../../../api/scopes.api";
  export default {
    name: "AllowedMobileCountries",
    components: {AppSection},
    props: {
      scope_id: null
    },
    data() {
      return {
        isLoading: false,
        allowedCountries: [],
        allCountries: countries
      }
    },
    methods: {
      getCountriesByISO2(countriesISO2) {
        return this.allCountries.filter(option => countriesISO2.findIndex(elem => elem === option.iso2) > -1)
      },
      getAllowedCountries() {
        this.isLoading = true;
        getAllowedMobileCountriesPerScope(this.scope_id).then(
          (response) => {
            const countriesISO2 = response.data.countries;
            if (countriesISO2 && countriesISO2.length) {
              this.allowedCountries = this.getCountriesByISO2(countriesISO2);
            }
            this.isLoading = false;
          },
          (error) => {
            this.isLoading = false;
            this.handleApiError(error);
          }
        )
      },
      updateAllowedCountries() {
        this.isLoading = true;
        const countries = this.allowedCountries.map((option) => option.iso2)
        addAllowedMobileCountries(this.scope_id, countries).then(
          (response) => {
            const countriesISO2 = response.data.countries;
            if (countriesISO2.length) {
              this.allowedCountries = this.getCountriesByISO2(countriesISO2);
            }
            this.isLoading = false;
          },
          (error) => {
            this.isLoading = false;
            this.handleApiError(error);
          }
        )
      }
    },
    created() {
      this.getAllowedCountries();
    }
  }
</script>

<style scoped>

</style>
